import React, { forwardRef, useImperativeHandle } from 'react';
import { useGradient } from './GradientContext';
import { Thumb } from './Thumb';
import { Track } from './Track';
import useForceUpdate from '~/hooks/useForceUpdate';

export type SliderRef = {
    forceUpdate: () => void;
};

export const Slider = forwardRef<SliderRef>(function Slider(_props, ref) {
    const { state } = useGradient();
    const forceUpdate = useForceUpdate();

    useImperativeHandle(
        ref,
        () => ({
            forceUpdate,
        }),
        [forceUpdate],
    );

    return (
        <Track>
            {state.gradient.stops.map((_, index) => (
                // We don't have a unique key for the color stops
                // eslint-disable-next-line react/no-array-index-key
                <Thumb key={index} index={index} />
            ))}
        </Track>
    );
});
